<!-- Full-page drop overlay -->
@if (isDragging()) {
    <div class="drop-overlay">
        <div class="drop-target">
            <fa-duotone-icon icon="cloud-arrow-up" size="4x" secondaryOpacity="0.4" class="text-primary mb-3" />
            <h4 class="mb-1">{{ DocumentsMessagingConstants.DOCUMENTS_UPLOAD_MULTI_HINT() }}</h4>
            <p class="mb-0 text-secondary">{{ maxFileSizeHint }}</p>
        </div>
    </div>
}

<!-- Upload progress dock -->
@if (uploads().length > 0) {
    <div class="upload-dock shadow-lg" [class.is-collapsed]="isDockCollapsed()">
        <div class="upload-dock-header" (click)="toggleDock()">
            <div class="d-flex align-items-center gap-2">
                @if (!isComplete()) {
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                        <span class="visually-hidden">Uploading</span>
                    </div>
                    <span class="fw-semibold">Uploading {{ currentPosition() }} of {{ summary().total }}…</span>
                    <span class="small text-secondary">{{ batchTotalLabel() }}</span>
                } @else if (summary().failed > 0) {
                    <fa-duotone-icon icon="circle-exclamation" class="text-warning" secondaryOpacity="0.9" />
                    <span class="fw-semibold">
                        {{ summary().done }} uploaded, {{ summary().failed }} failed
                    </span>
                } @else {
                    <fa-duotone-icon icon="circle-check" class="text-success" secondaryOpacity="0.9" />
                    <span class="fw-semibold">{{ summary().done }} uploaded</span>
                }
            </div>
            <div class="d-flex gap-1">
                <button type="button" class="btn btn-link dock-control" (click)="toggleDock(); $event.stopPropagation()"
                    [attr.aria-label]="isDockCollapsed() ? 'Expand' : 'Collapse'">
                    <fa-duotone-icon [icon]="isDockCollapsed() ? 'chevron-up' : 'chevron-down'" secondaryOpacity="0.9" />
                </button>
                @if (isComplete()) {
                    <button type="button" class="btn btn-link dock-control" (click)="dismissDock(); $event.stopPropagation()"
                        aria-label="Dismiss">
                        <fa-duotone-icon icon="xmark" secondaryOpacity="0.9" />
                    </button>
                }
            </div>
        </div>

        @if (!isDockCollapsed()) {
            <div class="upload-dock-body">
                @for (upload of uploads(); track upload.tempId) {
                    <div class="upload-row">
                        <fa-duotone-icon [icon]="statusIcon(upload.status)" [class]="statusClass(upload.status)" secondaryOpacity="0.9" />
                        <div class="upload-row-body">
                            <div class="d-flex justify-content-between align-items-baseline">
                                <span class="upload-name text-truncate" [msTooltip]="upload.fileName" msTooltipOnlyIfTruncated>{{ upload.fileName }}</span>
                                <span class="upload-percent small text-secondary">
                                    @if (upload.status === DocumentUploadStatus.Uploading) {
                                        {{ upload.percent }}%
                                    } @else {
                                        {{ statusLabel(upload.status) }}
                                    }
                                </span>
                            </div>
                            @if (upload.status === DocumentUploadStatus.Uploading || upload.status === DocumentUploadStatus.Done) {
                                <div class="progress upload-progress mt-1">
                                    <div class="progress-bar"
                                        [class.bg-success]="upload.status === DocumentUploadStatus.Done"
                                        [style.width.%]="upload.percent" role="progressbar"></div>
                                </div>
                            }
                            @if (upload.errorMessage) {
                                <div class="text-danger small mt-1">{{ upload.errorMessage }}</div>
                            }
                        </div>

                        @if (upload.status === DocumentUploadStatus.Pending || upload.status === DocumentUploadStatus.Uploading) {
                            <button type="button" class="btn btn-link dock-control" (click)="cancelUpload.emit(upload.tempId)" aria-label="Cancel upload">
                                <fa-duotone-icon icon="xmark" secondaryOpacity="0.9" />
                            </button>
                        } @else if (upload.status === DocumentUploadStatus.Failed && upload.retryable !== false) {
                            <button type="button" class="btn btn-link dock-control" (click)="retryUpload.emit(upload.tempId)" aria-label="Retry upload">
                                <fa-duotone-icon icon="arrow-rotate-right" secondaryOpacity="0.9" />
                            </button>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
